import eventBus from '../../vue-functions/event-bus';

function resetDestinationFilters() {
  eventBus.$emit('destinations-clear-values');

  this.clearDestinationValues();
  this.$data.settings.filtersText.destinationsText = false;
}
export default resetDestinationFilters;
